export const getTextAroundWord = (
  text: string,
  truncateLength: number,
  highlightTerm?: string,
): string => {
  const wrapper = document.createElement('div')
  wrapper.innerHTML = text

  const plainText = wrapper.textContent ?? ''
  if (!plainText) return text // nothing to do

  // 2.  Locate where we should begin the snippet.
  const hl = highlightTerm?.toLowerCase() ?? ''
  const termIndex =
    hl && plainText.toLowerCase().indexOf(hl) !== -1 ? plainText.toLowerCase().indexOf(hl) : 0

  // keep the highlight roughly in the middle of the snippet
  const half = Math.floor(truncateLength / 2)
  let startChar = Math.max(0, termIndex - half)
  let endChar = Math.min(plainText.length, startChar + truncateLength)

  // If the term is close to the end of the string, slide window left
  if (termIndex + hl.length > endChar) {
    endChar = Math.min(plainText.length, termIndex + hl.length)
    startChar = Math.max(0, endChar - truncateLength)
  }

  // 3.  Build a DOM Range that covers exactly [startChar, endChar)
  const range = document.createRange()
  const walker = document.createTreeWalker(wrapper, NodeFilter.SHOW_TEXT)

  let charCount = 0
  let rangeStarted = false

  while (walker.nextNode()) {
    const node = walker.currentNode as Text
    const nodeEnd = charCount + node.length

    if (!rangeStarted && startChar >= charCount && startChar <= nodeEnd) {
      range.setStart(node, startChar - charCount)
      rangeStarted = true
    }

    if (rangeStarted && endChar <= nodeEnd) {
      range.setEnd(node, endChar - charCount)
      break
    }

    charCount = nodeEnd
  }

  // 4.  Extract the fragment, convert back to HTML
  const fragWrapper = document.createElement('div')
  fragWrapper.appendChild(range.cloneContents())
  let snippet = fragWrapper.innerHTML

  // 5.  Add ellipses if we trimmed the original text
  if (startChar > 0) snippet = '…' + snippet
  if (endChar < plainText.length) snippet += '…'

  return snippet
}
